import {makeResource} from 'app/infrastructure/repository'
import { Driver } from './_models';

const ENDPOINT = 'drivers';

export default makeResource<Driver>(ENDPOINT);

